import DOMPurify from 'dompurify';

export const processHtmlForEditing = (htmlContent: string): string => {
  let html = DOMPurify.sanitize(htmlContent);

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  const listItems = tempDiv.querySelectorAll(
    'li:not([class*="checklist-item"])'
  );
  listItems.forEach((li) => {
    const p = document.createElement('p');
    const textContent = `• ${li.textContent?.trim() || ''}`;
    p.textContent = textContent;

    p.classList.add('bullet-item');
    if (li.getAttribute('style')) {
      p.setAttribute('style', li.getAttribute('style')!);
    }
    li.parentNode?.replaceChild(p, li);
  });

  html = tempDiv.innerHTML;

  const replacements: [RegExp, string][] = [
    [/<li[^>]*class="checklist-item[^"]*"[^>]*>/gi, '<p>'],
    [
      /<span[^>]*class="checklist-item__indicator"[^>]*>(☐|☑)<\/span>\s*<p[^>]*>/gi,
      '<p>$1&nbsp;',
    ],
    [
      /<span[^>]*class="checklist-item__indicator"[^>]*>(☐|☑)<\/span>/gi,
      '$1&nbsp;',
    ],
    [/<ul[^>]*class="checklist"[^>]*>|<ul[^>]*>|<\/ul>/gi, ''],
    [/<span[^>]*?(?:style="[^"]*")?[^>]*>(.*?)<\/span>/gi, '$1'],
    [/<p[^>]*>\s*<\/p>/gi, ''],
    [/(?<!☐&nbsp;|☑&nbsp;)\s{2,}/g, ' '],
  ];

  for (const [pattern, replacement] of replacements) {
    html = html.replace(pattern, replacement);
  }

  return html.trim();
};

export const convertToAhaChecklistHtml = (htmlContent: string): string => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlContent;

  const output: string[] = [];
  let checklistBuffer: string[] = [];

  const flushChecklist = () => {
    if (checklistBuffer.length > 0) {
      output.push(`<ul class="checklist">${checklistBuffer.join('')}</ul>`);
      checklistBuffer = [];
    }
  };

  tempDiv.childNodes.forEach((node) => {
    if (node instanceof HTMLElement && node.tagName === 'P') {
      const html = node.innerHTML.trim();
      const text = node.innerText.trim();
      if (text.startsWith('☐') || text.startsWith('☑')) {
        const checked = text.startsWith('☑');
        const symbol = checked ? '☑' : '☐';
        const labelHtml = html.replace(/^([☐☑])\s*/, '');
        const style = node.getAttribute('style');
        checklistBuffer.push(
          `<li class="checklist-item--${checked ? 'checked' : 'unchecked'}"${style ? ` style="${style}"` : ''}><span class="checklist-item__indicator">${symbol}</span><p${style ? ` style="${style}"` : ''}>${labelHtml}</p></li>`
        );
      } else {
        flushChecklist();
        output.push(node.outerHTML);
      }
    } else {
      flushChecklist();
      if (node instanceof HTMLElement) {
        output.push(node.outerHTML);
      }
    }
  });

  flushChecklist();
  return output.join('');
};
